export class Producto {
	constructor(		
		public nombre: string,
		public tipo: string,
		public sku: string,
		public bonus: boolean,
	) {}
}